<template>
	<div class="rating list-item-feature">
		<div class="title">Ranking</div>
		<div class="rating-content">
			<Loading v-if="calling" inline small />
			<template v-else>
				<span
					v-for="loopRating in ratings"
					:key="'rating' + loopRating"
					class="rating-star"
				>
					<span v-if="rating === loopRating || calling">
						<Icon :icon="rating >= loopRating ? 'star-filled' : 'star'"/>
					</span>
					<a
						v-else
						href="#"
						@click.prevent="save(loopRating)"
					>
						<Icon :icon="rating >= loopRating ? 'star-filled' : 'star'"/>
					</a>
				</span>
				<span v-if="lastModificationTimeStamp" class="last-modification-time-stamp">
					{{lastModificationTimeStamp | date }}
				</span>
			</template>
		</div>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import Icon from "@/vue/icon/Icon";
import CustomerSave from "@/api/customer/job-profile/applicant/rating/Save";
import ApplicationSave from "@/api/application/job-profile/Rating";
import {DateTime} from "luxon";
import * as Toast from "@/helper/layout/Toast";
import flatten from "@/helper/error/Errors";

export default {

	components: {
		Loading,
		Icon,
	},

	props: {
		type: {
			type: String,
			required: true,
		},
		jobProfileId: {
			type: String,
			required: true,
		},
		initialRating: {
			type: Object,
			required: false,
		},
		applicant: {
			type: Object,
			required: false,
		},
	},

	data ()
	{
		return {
			rating: this.initialRating?.rating || 0,
			lastModificationTimeStamp: this.initialRating?.lastModificationTimeStamp || null,
			calling: false,
			ratings: Object.freeze([1, 2, 3]),
		};
	},

	methods: {
		async save (rating)
		{
			this.calling = true;

			try
			{
				if (this.type === 'customer')
				{
					await new CustomerSave()
						.setJobProfileId(this.jobProfileId)
						.setPseudonymId(this.applicant.id)
						.setRating(rating)
						.call();
				}
				else
				{
					await new ApplicationSave()
						.setJobProfileId(this.jobProfileId)
						.setRating(rating)
						.call();
				}

				this.rating = rating;
				this.lastModificationTimeStamp = DateTime.now().toISODate();
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.calling = false;
		},
	},
}
</script>